// D24 (d24-v05 §1.1): regra única dos desfechos assíncronos da linha do tempo. Quem move o foco ou anuncia depois de uma requisição
// (NotaInterna: sucesso, posErro, Recarregar, reserva no título; ChipsRolagem: foco no chip ativo) confere antes onde o atendente está.
// - modalNaTela: um Swal na tela, inclusive o que está saindo (os 150 ms da animação, d24-v05 §1.4).
// - focoLivre: o foco está no <body>, num nó que saiu do DOM (trocado junto com a coluna) ou dentro do alvo (#ticket-detail-timeline).
// - podeFocar: as duas juntas. Se não pode, o foco NÃO se move e nada fica guardado para depois.

const modalNaTela = () => !!(window.Swal && typeof window.Swal.isVisible === 'function' && window.Swal.isVisible());

const focoLivre = (alvo) => {
    const a = document.activeElement;
    return !a || a === document.body || !a.isConnected || (!!alvo && alvo.isConnected && alvo.contains(a));
};

const podeFocar = (alvo) => !modalNaTela() && focoLivre(alvo);

module.exports = { modalNaTela, focoLivre, podeFocar };
